import { IOneMessageJson } from "../../../../../../nodeserver/structs/database.js";
import JSX from "../../../helpers/react.js";
import RefObject = JSX.RefObject;
import { disappearingElement, readNumberAttr} from "../../../messages/helpers.js";
import { ServerApi } from "../../../api.js";
import { handleFetchError, showNotice } from "../../../helpers/functions.js";
import { hideMessageText, showMessageText } from "../message.js";
import { blockActionsElementOrThrowErrorIfBlocked, hideAllActions, unblockActionsElement } from "../user-actions.js";
import { CustomSelectElement } from "../../../custom-elements/select-element/CustomSelectElement.js";



export function ReportActionElement(props: {
    msg: IOneMessageJson,
    message: RefObject<HTMLDivElement>,
    withText: boolean,
}){
    const reportElement = user_id !== props.msg.from_id ? (
        <div className="action-element"
             onClick={() => showReportElement(props.message.value!)}
        >
            <div className="message-action-padding">
                <img src="/img/report.svg" className="action-element-img"/>
            </div>
            {!!props.withText && <div className="message-action-padding main-red-font" style={{color: 'var(--light-text)'}}>Отправить жалобу</div>}
        </div>
    ) : <></>;
        return reportElement;
}


export function UserReportingMessageElement({message}: { message: RefObject<HTMLDivElement> }) {
    const values = userReportReasons();
    const html = (
        <div className="disappearing-element report-message">
            <div className="report-message-win">
                <div className="report-message-send-element">
                    <CustomSelectElement values={values} className="report-message-select"/>
                    <div className="claim-message-ok main-button"
                        onClick={() => sendReport(message.value!)}
                    >Отправить
                    </div>
                </div>
                <div className="report-message-win-close far fa-times-circle"
                    onClick={() => hideReportElement(message.value!)}/>
            </div>
        </div>
    );
    return html;
}


export function userReportReasons() {
    return [
        "Нецензурная лексика",
        "Оскорбления ",
        "Реклама сторонних ресурсов",
        "Спам / Флуд",
        "Злоупотребление капсом / эмодзи",
        "Политика",
    ];
}


export function hideReportElement(message: HTMLDivElement) {
    const messageId = +message.dataset["id"]!;
    unblockActionsElement(messageId);
    $(message).find(".report-message").addClass(disappearingElement);
    showMessageText(message);

}

export async function sendReport(message: HTMLDivElement) {
    const voteReason = $(message).find(".report-message-select .ss-disabled");
    const reason = readNumberAttr(voteReason, "value");

    if (!reason)
        return;

    hideReportElement(message!);

    try {
        let result = await ServerApi.messages.claimMessage(+message.dataset.id!, {
            reason: reason
        });

        if (result)
            showNotice("Ваша жалоба была отправлена!");


    } catch (e) {
        handleFetchError(e);
    }

}


export function showReportElement(message: HTMLDivElement) {
    const messageId = +message.dataset["id"]!;
    blockActionsElementOrThrowErrorIfBlocked(messageId);
    hideAllActions(message);

    $(message).find(".report-message").removeClass(disappearingElement);

    hideMessageText(message);
}